<template>
  <div
    id="slider"
    ref="scroller"
    :class="['min-h-screen relative h-screen overflow-auto']"
    :style="{
      'padding-top': setyleNavHeight + 'px',
      'padding-bottom': footerHeight + 'px'
    }"
  >
    <div
      v-if="topKind !== 'Submit'"
      class="fixed top-0 flex items-center justify-center w-full px-4 step-box scroller"
      :style="{
        top: `${clewordNavVisible ? setyleNavHeight : 0}px`
      }"
    >
      <div v-if="isSubmit" class="review-tag">回看</div>
      <div class="flex items-center justify-center w-full">
        <span class="text-lg current-step-number">{{ currentIndex + 1 }}</span>
        <span class="mx-px">/</span>
        <span>{{ sequenceTotal }}</span>
      </div>
      <div v-if="isSubmit" class="close-tag" @click="handleBackSubmit">关闭</div>
    </div>

    <section v-for="(content, index) in runderContents" :key="index" class="slide p-8 flex-1">
      <component
        :is="component(content)"
        ref="stepContent"
        :content="content"
        :step="currentIndex + 1"
        :isSubmit="isSubmit"
      />
    </section>
    <div
      class="footer"
      :style="{
        height: footerHeight + 'px'
      }"
    >
      <div v-if="topKind === 'Submit'" class="w-full h-full flex items-center justify-center">
        <div class="button text-button" @click.stop="handleControl('prev')">查看练习</div>
        <div class="button step-submut" @click.stop="handleClick">回到课堂</div>
        <div class="button text-button" @click.stop="handleScreenshot">保存图片</div>
      </div>
      <div v-else class="w-full">
        <div v-if="!progressHidden" class="w-full bg-motif-100">
          <div class="h-1 bg-motif" :style="progress"></div>
        </div>
        <div class="flex items-center justify-center py-2 w-full h-full bg-white">
          <div v-if="currentIndex" class="button step-button" @click="handleControl('prev')">
            上一页
          </div>
          <div
            v-if="currentIndex + 1 === sequenceTotal && !isSubmit"
            :class="['button step-submut', currentIndex ? '' : 'lang-button']"
            @click="handleClick"
          >
            提交
          </div>
          <div
            v-else
            :class="['button step-button', currentIndex ? '' : 'lang-button']"
            @click="handleClick"
          >
            下一页
          </div>
        </div>
      </div>
    </div>
    <PreviewScreemshot :url.sync="screenshotUrl" :visible.sync="screenshotModelVisible" />
    <!-- 重新学习按钮组 -->
    <div class="multifunction-slot">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Content, Sequence, Stmt } from '@forchange/storytime';

import { StepContent, StepSubmit } from '@/components/resources';
// models
import Dispatcher from '@/pages/main/models/Dispatcher';
import Slider from '@/pages/main/models/Slider';
import { namespace } from 'vuex-class';
import PreviewScreemshot from './components/PreviewScreemshot.vue';
import ScrollListenMixin from '@/mixins/scrollListen';

const commonModule = namespace('common');

const dispatcher = new Dispatcher({
  Step: StepContent,
  Submit: StepSubmit
});

let slider: null | Slider = null;

@Component({
  components: {
    PreviewScreemshot
  }
})
export default class StepPractice extends Mixins(ScrollListenMixin) {
  @Prop({ type: Object }) sequence!: Sequence & {
    progressShow?: '隐藏' | 'hidden';
  };
  @Prop() isInLookBack!: boolean;
  @commonModule.State('loading') globalLoading!: boolean;
  @commonModule.State('portalSequence') portalSequence!: Array<Sequence>;
  @commonModule.State('clewordNavVisible') clewordNavVisible!: boolean;

  currentIndex = 0;

  // footer height
  footerHeight = 54;

  // 屏幕截图
  screenshotUrl = '';
  screenshotModelVisible = false;

  get runderContents() {
    return this.filterContents(this.sequence.contents);
  }

  // 暂且已是否有submit content是否存在
  get isSubmit() {
    return this.runderContents.some((item) => item.$kind === 'Submit');
  }

  get occurredContentSize() {
    return window.storyteller.occurredContentIds.size;
  }

  get totalContentSize() {
    return window.storyteller.totalContentIds.size || 1;
  }

  get progress(): Object {
    if (window.storyteller.topContet?.$kind === 'End') {
      return {
        width: '100%'
      };
    }
    return {
      width: `${(this.occurredContentSize / this.totalContentSize) * 100}%`
    };
  }

  get sequenceTotal() {
    if (this.portalView) {
      return (this.portalView.contents as Array<Content>).filter(
        (content) => !['End', 'Submit'].includes(content.$kind)
      ).length;
    }
    return window.storyteller
      .getWorld()
      .frameStack.top()
      .stmts.filter(
        (item) => !!item.content?.$kind && !['End', 'Submit'].includes(item.content?.$kind)
      ).length;
  }

  get topKind() {
    if (this.portalView) {
      return (this.portalView.contents as Array<Content>)[this.currentIndex].$kind;
    }
    const sequenceTotal = window.storyteller
      .getWorld()
      .frameStack.top()
      .stmts.filter((item) => !!item.content?.$kind && !['End'].includes(item.content?.$kind));
    return (sequenceTotal as Array<Stmt>)[this.currentIndex]?.content?.$kind;
  }

  get portalView() {
    return this.portalSequence[this.portalSequence.length - 1];
  }

  get progressHidden() {
    return ['隐藏', 'hidden'].includes(this.sequence.progressShow || '');
  }

  private mounted() {
    this.initScrollListen(this.$refs.scroller as HTMLElement);
    this.init();
  }

  LoadImage(imageList: Array<string>) {
    if (!imageList.length) return;
    return new Promise((resolve) => {
      imageList.forEach((imageUrl) => {
        const newImage = new Image();
        newImage.src = imageUrl;
        newImage.onload = () => {
          resolve('onload');
        };
      });
    });
  }

  private filterContents(contents: Array<Content>): Array<Content> {
    return contents.filter((content) => content.$kind !== 'End');
  }

  private init() {
    slider = new Slider();
    slider.slideTo(this.lastContentIndex);
    this.onTouchEvent(slider);
    this.updateCurrentIndex();
  }

  private onTouchEvent(slider: Slider) {
    const handleEvent = ((event: CustomEvent) => {
      event.detail.direction && this.handleControl(event.detail.direction);
    }) as EventListener;
    slider.getRoot().addEventListener('slide', handleEvent, false);
    this.$once('hook:beforeDestroy', () => {
      slider.getRoot().removeEventListener('slide', handleEvent, false);
    });
  }

  private component(content: Content) {
    return dispatcher.dispatch(content);
  }

  private get lastContentIndex(): number {
    return this.runderContents.length - 1;
  }

  private _toLeft() {
    slider?.slidePrevious();
  }

  private _toRight() {
    slider?.slideNext();
  }

  private goTo(type: 'prev' | 'next') {
    const direction = { next: this._toRight, prev: this._toLeft };
    direction[type].call(this);
  }

  handleSequence(seq: Sequence) {
    this.$nextTick(() => {
      slider?.slideTo(this.filterContents(seq.contents).length - 1);
    });
  }

  private updateSeq() {
    if (this.globalLoading) return;
    if (this.portalView) return this.handleBack();
    if (!this.isInLookBack) {
      // 强制添加更新记录, 回看时禁用
      const currentContent = this.sequence.contents[this.currentIndex];
      window.storyteller.updateAssignContent({
        $id: currentContent.$id,
        $kind: currentContent.$kind
      });
    }

    window.next();
    this.handleSequence(this.sequence);
  }

  handleBack() {
    const portal = this.portalSequence[this.portalSequence.length - 1] as Sequence & {
      scrollTop: number;
    };
    if (portal) {
      this.$store.commit('common/setCallStatus', {
        isroll: false,
        rollHeight: portal.scrollTop
      });
    }
    this.$store.commit('common/setLoading', true);
    this.$store.commit('common/popPortal');
  }

  private handleControl(direction: 'prev' | 'next') {
    this.updateFildeStyle();
    if (slider?.isLastSlide() && direction === 'next') {
      this.updateSeq();
    } else {
      this.goTo(direction);
    }
    this.currenElTop();
    this.updateCurrentIndex();
  }

  currenElTop() {
    const slider = document.getElementById('slider') as HTMLDivElement;
    if (!slider) return;
    slider.scrollTop = 0;
  }

  async handleClick() {
    if (await this.checkSurveyEmpty()) return;
    this.updateFildeStyle();
    // 卡片视图 防止回顾比注册现行，手动延迟
    setTimeout(() => {
      this.handleControl('next');
    }, 100);
  }

  async checkSurveyEmpty() {
    // 校验题目填写
    const comps = this.$refs.stepContent as Array<
      Vue & {
        handleCheckField?: () => [];
        checkReviewSave: () => [];
        saveAnswer: (step: number) => void;
      }
    >;
    const currentComp = comps[this.currentIndex];
    if (!currentComp) return;
    if (currentComp.handleCheckField) {
      const emptyFields = currentComp.handleCheckField() as Array<Vue & { followField: Function }>;
      if (emptyFields?.length && !this.isSubmit) {
        // 定位异常题目
        emptyFields[0].followField();
        this.$Message.warn({
          time: 1500,
          content: '请先将题目按要求填写完成哦'
        });
        return true;
      }
    }
    if (currentComp.checkReviewSave) {
      const emptyReviews = currentComp.checkReviewSave() as Array<Vue & { followReview: Function }>;
      if (emptyReviews?.length && !this.isSubmit) {
        // 定位异常题目
        emptyReviews[0].followReview();
        this.$Message.warn({
          time: 1500,
          content: '请先保存回顾再进行下一步哦'
        });
        return true;
      }
    }
    currentComp.saveAnswer && (await currentComp.saveAnswer(this.currentIndex + 1));
  }

  updateCurrentIndex() {
    setTimeout(() => {
      this.currentIndex = slider?.getCurrentSlideIndex() || 0;
    }, 10);
  }

  handleScreenshot() {
    this.screenshotModelVisible = true;
    // settimeout 确保弹框先渲染
    setTimeout(async () => {
      const comps = this.$refs.stepContent as Array<Vue & { screenshot: () => string }>;
      const currentComp = comps[this.currentIndex];
      if (!currentComp) return;
      this.screenshotUrl = await currentComp?.screenshot();
    }, 0);
  }

  handleBackSubmit() {
    let submitIndex = this.runderContents.findIndex((content) => content.$kind === 'Submit');
    if (submitIndex) submitIndex = submitIndex + 1;
    submitIndex = this.lastContentIndex;
    slider?.slideTo(submitIndex);
    this.updateCurrentIndex();
  }

  updateFildeStyle() {
    setTimeout(() => {
      const comps = this.$refs.stepContent as Array<Vue & { changeReviewSurvey: Function }>;
      comps &&
        comps.forEach((comp) => {
          comp.changeReviewSurvey && comp.changeReviewSurvey();
        });
    }, 0);
  }
}
</script>
<style scoped>
.step-box {
  flex: 0 0 36px;
  color: #b2b2cd;
  background: #fbfbfb;
}

.scroller {
  transition: all 0.5s;
}

.review-tag {
  @apply w-14 h-6 rounded-full text-center;
  color: white;
  background: #6fe2bf;
}

.close-tag {
  @apply w-14 h-6 rounded-full text-center cursor-pointer;
  color: rgba(0, 0, 0, 0.8);
}

.current-step-number {
  @apply text-motif-500;
}
.pagination {
  @apply fixed bottom-4 left-1/2 border rounded-md py-1 pl-3 pr-4 text-xs tracking-widest text-gray-600 bg-gray-100;
  transform: translateX(-50%);
}
.pagination span {
  @apply ml-1;
}
.footer {
  @apply w-full fixed bottom-0 bg-white;
  box-shadow: 2px 0 32px 0px rgb(0 0 0 / 5%);
}

.button {
  @apply text-center mx-3 cursor-pointer;
  width: 240px;
  height: 40px;
  line-height: 40px;
}

@screen md {
  .lang-button {
    width: 499px;
  }
}

.step-button {
  @apply text-motif-500 border-motif-500;
  border: 1px solid;
  border-radius: 6px;
}

.step-button:active {
  @apply bg-gray-100;
}

.step-submut {
  @apply bg-motif hover:opacity-hover active:opacity-active border-motif-500;
  color: white;
  border: 1px solid;
  border-radius: 6px;
}
/* 
.step-submut:active {
  opacity: 0.7;
} */

.text-button {
  @apply text-motif-500;
}

.text-button:active {
  opacity: 0.7;
}

/* slot position */
.multifunction-slot {
  @apply fixed right-4 bottom-20;
}
</style>
